import PropTypes from "prop-types";
import { useState } from "react";
import Button from "solar/components/Button";
import Slideshow from "components/shared/stays/Slideshow";
import PhotosGrid from "components/shared/stays/PhotosGrid";
import styles from "components/shared/stays/GalleryTwoUp.module.scss";

export default function GalleryTwoUp({
  photos,
  photoAlt,
  showButton = false,
  buttonText = "Show all photos",
  prioritizeFirstPhoto = false,
}) {
  const [showSlideshow, setShowSlideshow] = useState(false);
  const [activeSlide, setActiveSlide] = useState(1);
  const handleCloseSlideshow = () => setShowSlideshow(false);
  const handleShowSlideshow = (active) => {
    setShowSlideshow(true);
    setActiveSlide(active);
  };

  return (
    <>
      <PhotosGrid
        photos={photos}
        photoAlt={photoAlt}
        onClick={handleShowSlideshow}
        showButton={showButton}
        prioritizeFirstPhoto={prioritizeFirstPhoto}
      />
      {showButton && photos.length > 2 && (
        <Button
          onClick={() => handleShowSlideshow(1)}
          ghost
          size={1}
          responsive
          className={styles.button}
        >
          {buttonText}
        </Button>
      )}
      {photos.length > 1 && (
        <Slideshow
          show={showSlideshow}
          handleClose={handleCloseSlideshow}
          initialSlide={activeSlide}
          slides={photos}
        />
      )}
    </>
  );
}

GalleryTwoUp.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
      }),
    })
  ).isRequired,
  photoAlt: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  buttonText: PropTypes.string,
  prioritizeFirstPhoto: PropTypes.bool,
};
